package com.schoolconnect.app.feature.attendance

import androidx.compose.ui.graphics.Color
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOrangeText
import com.schoolconnect.app.designsystem.AppSuccess

internal fun attendanceStatusColor(status: String): Color = when (status.trim().uppercase()) {
    "P" -> AppSuccess
    "A" -> AppDanger
    "A-M", "A-A" -> AppOrangeText
    else -> AppNavy
}
